import { Carousel } from "./carousel";
import { useState, useRef } from "react";
import { Box, Flex, Heading, Text } from "rebass";
import { display, maxWidth } from "styled-system";
import styled from "styled-components";
import * as Scroll from "react-scroll";
import { Button } from "./button";
import { DynamicNextLink } from "./dynamic-next-link";

const FeaturedItems = ({ items }) => {
  const [current, setCurrent] = useState(0);
  const contentRef = useRef();

  const scroll = Scroll.animateScroll;

  const slides = items.map(item => ({
    image: item.image,
    link: item.link
  }));

  const onBeforeChange = (current, next) => {
    setCurrent(next);
    checkScroll(contentRef.current);
  };

  const checkScroll = element => {
    const offset = element.offsetTop - window.scrollY;
    if (offset > 0) {
      scroll.scrollMore(offset, { smooth: true, duration: 500 });
    }
  };

  const ItemContent = ({ active, title, details, excerpt, link, rsvp }) => {
    return (
      <DisplayContainer display={active ? "block" : "none"}>
        <Flex flexWrap="wrap" mt={3}>
          <Box width={[1, 1, 1, 5 / 12]}>
            {title && (
              <S_Heading
                pr={[0, 0, 0, 4]}
                as="h3"
                fontSize={[4, 4, 5, 6]}
                fontFamily="medium"
                color="blue.2"
                letterSpacing={1}
                lineHeight={1}
              >
                <S_DynamicNextLink link={link} color="blue.2">
                  {title}
                </S_DynamicNextLink>
              </S_Heading>
            )}

            {details && (
              <Text
                mt={3}
                fontSize={1}
                letterSpacing={0.12}
                color="blue.1"
                fontFamily="medium"
              >
                {details}
              </Text>
            )}
          </Box>
          <Box width={[1, 1, 1, 7 / 12]}>
            {excerpt && (
              <Text mt={[3, 3, 3, 0]} fontSize={[2, 2, 2, 3]} lineHeight={1.5}>
                {excerpt}
              </Text>
            )}

            {link && (
              <Text
                mt={3}
                color="blue.1"
                fontSize={1}
                letterSpacing={0.12}
                fontFamily="medium"
              >
                <S_DynamicNextLink link={link}>Read More</S_DynamicNextLink>
              </Text>
            )}

            {rsvp && rsvp.url && (
              <Box mt={4}>
                <Button
                  text="Event Page"
                  link={{
                    internal: false,
                    href: rsvp.url
                  }}
                  variant="blue"
                />
              </Box>
            )}
          </Box>
        </Flex>
      </DisplayContainer>
    );
  };

  return (
    <Box bg="white" color="black" ref={contentRef}>
      <Carousel slides={slides} onBeforeChange={onBeforeChange} />
      <Box px={[3, 3, 3, 4]} pb={[4, 4, 4, 6]}>
        <ContentContainer mx="auto" maxWidth={2}>
          {items.map((event, i) => (
            <ItemContent
              key={i}
              active={i === current}
              start_date={event.start_date}
              end_date={event.end_date}
              title={event.title}
              details={event.details}
              excerpt={event.excerpt}
              link={event.link}
              rsvp={event.rsvp}
            />
          ))}
        </ContentContainer>
      </Box>
    </Box>
  );
};

const ContentContainer = styled(Box)`
  ${maxWidth}
`;

const DisplayContainer = styled(Box)`
  ${display}
`;

const S_Heading = styled(Heading)`
  text-transform: uppercase;
`;

const S_DynamicNextLink = styled(DynamicNextLink)`
  a:hover {
    text-decoration: underline;
  }
`;

export { FeaturedItems };
